import React from "react";
import moment from "moment";

import { IColum } from "../../../../utils/copyToClipboardInXlsFormat";
import { ISubmissionToProp } from "../../../../api/fundedCompliance/index.types";
import { AccountComplianceStatusSelect } from "../../../../components/ui";
import EntriesIdWithPrefix, { getEntriesIdWithPrefix } from "../EntriesIdWithPrefix";

export const SUBMISSION_TO_PROP_COLUMNS: Array<IColum> = [
  {
    by: "compliance_entries_id",
    title: "Entries ID",
    path: "funded_trader.account.compliance_traders_account.compliance_ent",
    isSortable: true,
    //@ts-ignore
    getCellValue: (value, restValues: ISubmissionToProp) => {
      return (
        <EntriesIdWithPrefix
          multiplePasses={!!restValues.multiPasses.length}
          entriesId={value as unknown as number}
        />
      );
    },
    copyToClipBoardCallBack: (value) => getEntriesIdWithPrefix(value as unknown as number),
  },
  {
    by: "timestamp",
    title: "Timestamp",
    path: "timestamp",
    //@ts-ignore
    getCellValue: (timestamp, restValues: ISubmissionToProp) => {
      const timestamps = [timestamp, ...restValues.multiPasses.map((pass) => pass.timestamp)];
      return (
        <div>
          {timestamps.map((time, index) => (
            <p key={`${time}_${index}`}>{moment(time as string).format("DD/MM/YYYY HH:mm:ss")}</p>
          ))}
        </div>
      );
    },
    isSortable: true,
    copyToClipBoardCallBack(timestamp: string): string {
      return moment(timestamp as string).format("DD/MM/YYYY HH:mm:ss");
    },
  },
  {
    by: "account.name",
    title: "Name",
    path: "account.name",
    //@ts-ignore
    getCellValue: (name: string, restValues: ISubmissionToProp) => {
      const names = [];
      if (name) {
        names.push(name);
      }
      if (!name && restValues?.funded_trader?.account?.name) {
        names.push(restValues.funded_trader.account.name);
      }

      if (restValues.multiPasses.length) {
        names.push(...restValues.multiPasses.map((pass) => pass["account.name"]));
      }

      return (
        <div>
          {names.map((name, index) => (
            <p key={`${name}${index}`}>{name}</p>
          ))}
        </div>
      );
    },
    // isSortable: true,
  },
  {
    by: "email",
    title: "Email",
    path: "account.email",
    //@ts-ignore
    getCellValue: (email: string, restValues: ISubmissionToProp) => {
      const emails = [];
      if (email) {
        emails.push(email);
      }
      if (restValues?.funded_trader?.account?.email) {
        emails.push(restValues.funded_trader.account.email);
      }
      if (restValues.multiPasses.length) {
        emails.push(...restValues.multiPasses.map((pass) => pass["account.email"]));
      }
      return (
        <div>
          {emails.map((email, index) => (
            <p key={`${email}${index}`}>{email}</p>
          ))}
        </div>
      );
    },
  },
  {
    by: "e2t_account_id",
    title: "Passed evaluation account",
    path: "e2t_account_id",
    isSortable: true,
    //@ts-ignore
    getCellValue: (e2t_account_id: string, restValues: ISubmissionToProp) => {
      const accountIds = [
        e2t_account_id,
        ...restValues.multiPasses.map((pass) => pass.e2t_account_id),
      ];
      return (
        <div>
          {accountIds.map((id, index) => (
            <p key={`${id}${index}`}>{id}</p>
          ))}
        </div>
      );
    },
  },
  {
    by: "type_and_size",
    title: "Account size",
    path: "type_and_size",
    isSortable: true,
    //@ts-ignore
    getCellValue: (type_and_size: string, restValues: ISubmissionToProp) => {
      const types = [type_and_size, ...restValues.multiPasses.map((pass) => pass.type_and_size)];
      return (
        <div>
          {types.map((id, index) => (
            <p key={`${id}${index}`}>{id}</p>
          ))}
        </div>
      );
    },
  },
  {
    by: "compliance_status",
    title: "Compliance status",
    path: "compliance_status",
    //@ts-ignore
    getCellValue: (complianceStatus: string, restValues: ISubmissionToProp): React.ReactElement => {
      const complianceStatuses = [
        { id: restValues.id, status: complianceStatus },
        ...restValues.multiPasses.map((pass) => ({ id: pass.id, status: pass.compliance_status })),
      ];
      return (
        <div>
          {complianceStatuses.map(({ id, status }, index) => (
            <AccountComplianceStatusSelect
              key={`${id}${index}`}
              id={id}
              status={status as string}
            />
          ))}
        </div>
      );
    },
    isSortable: true,
  },
  {
    by: "watchlist_notes",
    title: "Measure taken",
    path: "watchlist_notes",
    //@ts-ignore
    getCellValue: (watchlistNotes: ISubmissionToProp["watchlist_notes"]) => {
      return watchlistNotes.map((note, index) => {
        return <p key={`${index}`}>{note.measure_taken}</p>;
      });
    },
    //@ts-ignore
    copyToClipBoardCallBack(watchlistNotes: ISubmissionToProp["watchlist_notes"]): string {
      return watchlistNotes
        .map((note) => {
          return note.measure_taken;
        })
        .join(", ");
    },
  },
  {
    by: "watchlist_timestamp",
    title: "Measure timestamp",
    path: "watchlist_notes",
    //@ts-ignore
    getCellValue: (watchlistNotes: ISubmissionToProp["watchlist_notes"]): React.ReactElement[] => {
      return watchlistNotes.map((note, index) => {
        return <p key={`${index}`}>{note.measure_timestamp}</p>;
      });
    },
    //@ts-ignore
    copyToClipBoardCallBack(watchlistNotes: ISubmissionToProp["watchlist_notes"]): string {
      return watchlistNotes
        .map((note) => {
          return note.measure_timestamp;
        })
        .join(", ");
    },
  },
];

export const SUBMISSION_TO_PROP_FILTER_OPTIONS = {
  "Entries ID": "compliance_entries_id",
  Name: "names",
  Email: "emails",
};
